import React from 'react';
import UserAdsContainer from '../../../Containers/UserContainer/Ads';

const UserAdsScreen = () => {
  return <UserAdsContainer />;
};

export default UserAdsScreen;
